import React, { useContext } from "react";
import { func, array, number } from "prop-types";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import { GeneralWrapper } from "./QuestionsPanel.styled";
import TonalityIcon from "@material-ui/icons/Tonality";
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";
import SentimentSatisfiedOutlinedIcon from "@material-ui/icons/SentimentSatisfiedOutlined";
import StarOutlineRoundedIcon from "@material-ui/icons/StarOutlineRounded";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { NotificationManager } from "react-notifications";
import { ReactComponent as DropdownIcon } from "../../assets/svg/dropdown-question-icon.svg";
import { ReactComponent as AttachFileIconPlus } from "../../assets/svg/attach-file-icon.svg";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PublicIcon from "@mui/icons-material/Public";

const QuestionsPanel = ({ idSurvey, identity, dataEditSurvey }) => {
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);

  const addQuestion = (type, isEdit = true) => {
    if (
      stateQuestionsReducer.questions.filter((f) => f.GisEdit === true).length
    ) {
      NotificationManager.warning(
        "All questions must be saved before to add another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "ADD_QUESTIONS",
      payload: {
        Gtype: type,
        GindexQuestion: stateQuestionsReducer.questions.length,
        Gactive: true,
        GidSurvey: idSurvey,
        GidQuestion: 0,
        GidCategoryQuestion: 0,
        GnameQuestion: "",
        GvalidationText: "",
        GidQuestionSurvey: 0,
        GisMandatory: false,
        GjsonConfiguration: "",
        Gorder: stateQuestionsReducer.questions.length + 1,
        GisEdit: isEdit,
        GisDependent: false,
        GidParentQuestion: null,
        GdependentAnswer: null,
      },
    });
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <GeneralWrapper
        onClick={() => {
          addQuestion("OpenText");
        }}
      >
        <BorderColorIcon></BorderColorIcon>
        Open Text
      </GeneralWrapper>
      <GeneralWrapper
        onClick={() => {
          addQuestion("ImageRating");
        }}
      >
        <StarOutlineRoundedIcon></StarOutlineRoundedIcon>
        {identity !== "form" ? "Image Rating" : "Image / Number Scale"}
      </GeneralWrapper>

      <GeneralWrapper
        onClick={() => {
          addQuestion("MultipleChoiceMultiSelect");
        }}
      >
        <FormatListBulletedIcon />
        Multiple Choice (Multi select)
      </GeneralWrapper>

      <GeneralWrapper
        onClick={() => {
          addQuestion("MultipleChoiceSingleSelect");
        }}
      >
        <FormatListBulletedIcon />
        Multiple Choice (Single select)
      </GeneralWrapper>

      {identity !== "form" && (
        <GeneralWrapper
          onClick={() => {
            addQuestion("MultipleChoiceImageSingleSelect");
          }}
        >
          <FormatListBulletedIcon />
          Image Choice (Single select)
        </GeneralWrapper>
      )}
      {identity !== "form" && (
        <GeneralWrapper
          onClick={() => {
            addQuestion("SmileyFaces");
          }}
        >
          <SentimentSatisfiedOutlinedIcon></SentimentSatisfiedOutlinedIcon>
          Smiley Face Scale
        </GeneralWrapper>
      )}

      <GeneralWrapper
        onClick={() => {
          addQuestion("QuestionYesNo");
        }}
      >
        <TonalityIcon />
        Yes / No
      </GeneralWrapper>

      {identity !== "form" && (
        <GeneralWrapper
          onClick={() => {
            addQuestion("QuestionLike");
          }}
        >
          <ThumbUpAltOutlinedIcon />
          Like
        </GeneralWrapper>
      )}
      <GeneralWrapper
        onClick={() => {
          addQuestion("DropdownSingleSelect");
        }}
      >
        <DropdownIcon />
        Dropdown
      </GeneralWrapper>
      {identity === "form" && (
        <GeneralWrapper
          onClick={() => {
            addQuestion("File", false);
          }}
        >
          <AttachFileIconPlus />
          Attach file
        </GeneralWrapper>
      )}
      {identity !== "form" && (
        <GeneralWrapper
          onClick={() => {
            addQuestion("Date");
          }}
        >
          <DateRangeIcon />
          Date
        </GeneralWrapper>
      )}
      {identity !== "form" && (
        <GeneralWrapper
          onClick={() => {
            addQuestion("File");
          }}
        >
          <AttachFileIcon />
          Attach file
        </GeneralWrapper>
      )}
      {identity === "form" && (
        <GeneralWrapper
          hidden={true}
          onClick={() => {
            addQuestion("Location");
          }}
        >
          <PublicIcon />
          Location
        </GeneralWrapper>
      )}
    </div>
  );
};

QuestionsPanel.propTypes = {
  idSurvey: number.isRequired,
  questionBlocks: array.isRequired,
  setQuestionBlocks: func.isRequired,
  setKeyAndId: func.isRequired,
  keyAndId: array.isRequired,
};

export default QuestionsPanel;
